import SelectedTargetsList from './SelectedTargetsList';

export default SelectedTargetsList;
